import { LOCATARIOS } from '../actions/types';

const initialState = {
    listado: [],
    detalles: null, 
    listado_usuarios: [],
    detalles_usuario: null,
    ventana_filtros: false, 
    filtros: null
};

export default (state = initialState, action) => {

    const { type, payload } = action;

    switch ( type ) {
        case LOCATARIOS.BUSCAR:
            return {
                ...state,
                listado: payload
            };

        case LOCATARIOS.DETALLES:
            return {
                ...state,
                detalles: payload
            };

        case LOCATARIOS.EDITAR:
            return {
                detalles: {
                    ...state.detalles,
                    informacion_personal: {
                        ...state.detalles.informacion_personal,
                        status: payload.status
                    }
                },
                listado: state.listado.map(
                    empresa => empresa._id === payload._id 
                        ? 
                            {
                                ...empresa,
                                status: payload.status
                            } 
                        : 
                            empresa
                )
            };

        case LOCATARIOS.RENTAS:
            return {
                ...state, 
                detalles: {
                    ...state.detalles, 
                    rentas: payload
                }
            };

        case LOCATARIOS.ELIMINAR:
            return {
                ...state,
                listado: state.listado.filter( empresa => empresa._id !== payload.id )
            };

        case LOCATARIOS.FILTROS:
            return {
                ...state,
                ventana_filtros: payload
            };

        case LOCATARIOS.USUARIOS.BUSCAR:
            return {
                ...state,
                listado_usuarios: payload
            };

        case LOCATARIOS.USUARIOS.AGREGAR:
            return {
                ...state,
                listado_usuarios: [
                    ...state.listado_usuarios, payload
                ]
            };

        case LOCATARIOS.USUARIOS.DETALLES:
            return {
                ...state,
                detalles_usuario: payload
            };

        case LOCATARIOS.USUARIOS.EDITAR:
            return {
                ...state,
                listado_usuarios: state.listado_usuarios.map(usuario => usuario._id === payload._id ? payload : usuario)
            };

        case LOCATARIOS.USUARIOS.ELIMINAR:
            return {
                ...state,
                listado_usuarios: state.listado_usuarios.filter( usuario => usuario._id !== payload.id )
            };

        default:
            return state;
    }
}